import { nodeListToArray } from '../helpers/nodeListToArray';
import inlineTrim from '../modules/read-more-less-trim';
import moment from 'moment';

export interface ICarousel {
    width?: number;
    containerClass: string;
    slidesPerView?: number;
    centeredSlides?: boolean;
    breakpoints?: any;
    spaceBetween?: number;
    navigation?: any;
    autoHeight?: boolean;
    height?: number;
    loop?: boolean;
    autoplayVideo?: boolean;
    pageNumberPreposition?: string;
    watchSlidesVisibility?: boolean;
}
interface IPersonalizedProductData {
    authors: IAuthor[];
    itemNumber: string;
    itemName: string;
    newUntilDate: string;
    itemPublicationDate: string;
    startDate: string;
    endDate: string;
    bestseller: boolean;
    itemMemberPrice: number;
    itemRetailPrice: number;
    pricesLoading: boolean;
    isMemberBenefit: boolean;
    format: string;
    url: string;
    productImage: string;
    fullLocation: string;
    state: string;
    tags: string[];
    showAvailabilityDates: boolean;
    showPublicationDate: boolean;
    shortDescription: string;
    externalRegistrationUrl: string;
    category: string;
    isQuantityDiscount: boolean;
    healthyChildrenProduct: boolean;
    relevance: number;
    isMember: boolean;
    customFilterValues: string[];
    topics: string[];
    productType: ProductType;
    data: any;
    itemDisplayDate: string;
}

interface IAuthor {
    authorName: string;
    authorBio: string;
    authorOfRole: string;
    authorOfDescription: string;
}

interface IPersonalizedProducts {
    alias: string;
    position: string;
    recs: IPersonalizedProduct[];
    widget: string;
}

interface IPersonalizedProduct {
    id: number;
    img: string;
    refCode: string;
    title: string;
    url: URL;
    prices: IPriceType[];
}

interface IPriceType {
    USD: IPrice;
}

interface IPrice {
    salePrice: number;
    unitPrice: number;
}

enum ProductType {
    BOOK,
    EBOOK,
    JOURNAL,
    LIVE_ACTIVITY,
    COURSE,
    BROCHURE,
    POINT_OF_CARE,
    DEFAULT
}

declare global {
    interface Window {
        InitPeeriusRecommendationsForRecommendedCoursesBlock: (data: any) => void
    }
}
window.InitPeeriusRecommendationsForRecommendedCoursesBlock = function (data) {
    const recClass = 'peerius-reccomended-courses';
    const courseRecs = nodeListToArray(document.querySelectorAll('[data-recommended-courses-campaign]'));

    if (courseRecs.length > 0) {
        courseRecs.forEach((course, index) => {
            course.classList.add(`${recClass}-${index}`);
            renderRecs(data[0], `${recClass}-${index}`, course)
        });
    }

}

export function renderRecs(peeriusData: any, recClass, courseWrapper) {
    var count = 0;
    var promiseCount = 0;
    if (peeriusData == undefined || peeriusData.recs == undefined) {
        return;
    }
    let firstRecs = peeriusData.recs.slice(0, 4);
    // get the first four reccommendations and append them to the block
    firstRecs.forEach(rec => {
        getProductData(rec.refCode, count, courseWrapper).then(res => {
            promiseCount++;
            if (promiseCount === firstRecs.length) {
                //post render effects if any
                inlineTrim;
            }
        });
        count++;
    });
}
//takes a single peerius recommended content item and gets the corresponding item from the search api
function getProductData(refCode: string, index: number, courseWrapper: Element) {
    const init: RequestInit = {
        method: 'GET',
        credentials: 'same-origin'
    };

    return window.fetch(`/api/v1/search/getProduct?refCode=${refCode}`, init)
        .then(res => {
            if (res.status !== 200) {
                throw new Error(res.statusText);
            }
            return res.text().then(data => {
                renderCourseItem(data as any, index, courseWrapper);
            });
        });
}
function renderCourseItem(productData: any, index: number, courseWrapper: Element) {
    var parsedData = JSON.parse(productData) as IPersonalizedProductData;
    var ctaText = (window as any).recommendedCoursesBlockBootstrap.ctaText;

    var courseItem = document.createElement('div');
    courseItem.setAttribute('class', 'rec-course-item');
    courseItem.setAttribute('data-course-item', index.toString());
    if (parsedData != null && parsedData.data != null && parsedData !== undefined && parsedData.data !== undefined) {
        let displayDate = parsedData.data.itemDisplayDate;
    

    courseItem.innerHTML = `
        <div class="data-wrap">
            <div class="rec-course-item-image"><a href="${parsedData.data.url}"><img class="rec-course-image" alt="" src="${parsedData.data.productImage}" /></a></div>
            <div class="rec-course-item-content">
                <div class="rec-course-item-title"><a class="h4-styled">${parsedData.data.itemName}</a> <a class="btn button-primary rec-course-item-btn" href="${parsedData.data.url}">${ctaText}</a></div>
                <div class="rec-course-item-date"><svg class="rec-course-item-icon icon-Expire-(1)" height="16px" width="16px"><use xlink:href="#icon-calendar-(1)"></use></svg><span>Available: ${displayDate}</span></div>
                <div class="rec-course-item-desc trim"><p>${parsedData.data.searchSummaryText}</p></div>
            </div>
        </div>
    `;
    
    courseWrapper.append(courseItem);
    
    }
}
